import React from 'react';
import { useAuthProvider } from '../contexts/AuthProvider';
import { useSafeEffect } from '../hooks/use-safe-effect';

export function RequiresAuthenticationState(props: { children?: React.ReactNode; loader: React.ReactNode }) {
    const context = useAuthProvider();

    useSafeEffect(() => {
        if (!context.initialized) {
            context.instance.initialize();
        }
    }, [context, context.initialized]);

    if (!context.initialized) {
        return props.loader;
    }

    return <>{props.children}</>;
}
